export function matchKeyword(content: string, keyword: string): string[] {
    const punctuationsPattern = /[!@#$%\^\&*()_+\-=\[\]\\\{\}'"`~\/\?<>,\.\|:;]/mg;
    const finalKeyWord = keyword.replace(punctuationsPattern, ' ');
    let words = finalKeyWord.split(/\s/);
    words = words.filter((word) => !!word);

    // const finalContent = content.replace(punctuationsPattern, ' ');
    const finalContent = content;

    // 如果是多个词，确保一定是都包含才进行匹配
    if (words.length) {
        for (const w of words) {
            if (finalContent.indexOf(w) === -1) {
                return [];
            }
        }
    }
    // 先构建正则进行匹配，然后记录下每一次符合的记录出现的位置
    // 根据匹配的位置，截取多个片段
    const keyWordPattern = new RegExp(`(${words.join(')|(')})`, 'gim');

    const matchIndexes: number[] = [];
    while (true) {
        const matchArr: RegExpExecArray | null = keyWordPattern.exec(finalContent);
        if (!matchArr) {
            break;
        }
        matchIndexes.push(matchArr.index);
    }
    if (!matchIndexes.length) {
        return [];
    }
    const matchContents: string[] = [];
    let fragmentEndIndex: number = -1;
    for (const matchIndex of matchIndexes) {
        if (matchIndex < fragmentEndIndex) {
            continue;
        }
        let start = matchIndex - 10;
        if (start < 0) {
            start = 0;
        }
        let end = start + 100;
        if (end > finalContent.length - 1) {
            end = finalContent.length - 1;
        }
        fragmentEndIndex = end;
        let fragment = finalContent.substring(start, end + 1);
        fragment = fragment.replace(keyWordPattern, (str) => `<em>${str}</em>`);
        matchContents.push(fragment);
    }
    return matchContents;
}
